export const KeyCodes = {
    ENTER: 13,
    SPACE: 32,
    ESCAPE: 27,
    BACKSPACE: 8,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};